<template>
	<div class="row mb-3 personal-admin testigos-admin">
		<b-modal ref="new-testigo" hide-footer title="Agregar testigo" size="xl" no-close-on-backdrop>
			<div class="row">
				<div class="col-6 mb-2">
					<label for="">Buscar por numero de cedula: </label>
					<Persona @setPersona="setPersona" />
				</div>

				<div class="col-12" v-if="results">					
					<p><strong>{{testigo.nom1}} {{testigo.nom2}} {{testigo.ape1}} {{testigo.ape2}} {{testigo.nombre_puesto}} MESA: {{testigo.mesa}}</strong></p>
				</div>
                <div class="col-12 mb-2">
                    <label for="testigo-puesto">Puesto de votación</label>
                    <a-select id="testigo-puesto" v-model="puestoRegistro" show-search :filter-option="filtrarLider"
                        :loading="loader" :disabled="loader" placeholder="Buscar puesto de votación"
                        style="width: 100%" aria-label="Puesto de votación del testigo"
                        :not-found-content="loader ? 'Cargando puestos…' : 'No se encontraron puestos en el municipio'">
                        <a-select-option v-for="puesto in puestosMunicipio" :key="clavePuesto(puesto)" :value="clavePuesto(puesto)" :title="puesto.nombre_puesto">
                            {{ puesto.nombre_puesto }}
                        </a-select-option>
                    </a-select>
                    <div v-if="errorPuestos" class="text-danger" role="alert">{{ errorPuestos }} <button type="button" class="btn btn-link" @click="getDivipole">Reintentar</button></div>
                    <small v-else-if="results && !puestoRegistro" class="text-muted">Selecciona un puesto del municipio para asignar las mesas.</small>
                </div>
				<div class="col-6">
					<label for="partido">Partido</label>
					<model-select :options="partidos" v-model="testigo.partido_id"></model-select>
				</div>
                <div class="col-12 col-md-6 mb-2">
                    <label for="testigo-lider">Líder</label>
                    <a-select id="testigo-lider" v-model="testigo.lidere_id" show-search allow-clear
                        :filter-option="filtrarLider" :loading="cargandoLideres" :disabled="cargandoLideres"
                        placeholder="Buscar líder por nombre o apellido" style="width: 100%" aria-label="Líder del testigo"
                        :not-found-content="cargandoLideres ? 'Cargando líderes…' : 'No se encontraron líderes'">
                        <a-select-option v-for="lider in lideres" :key="lider.id" :value="lider.id" :title="[lider.nombres, lider.apellidos].filter(Boolean).join(' ')">
                            {{ [lider.nombres, lider.apellidos].filter(Boolean).join(' ') }}
                        </a-select-option>
                    </a-select>
                    <div v-if="errorLideres" class="text-danger mt-1" role="alert">
                        {{ errorLideres }} <button type="button" class="btn btn-link p-0" @click="getLideres">Reintentar</button>
                    </div>
                </div>
				<div class="col-6">
					<label for="email">Email</label>
					<input type="email" class="form-control" id="email" v-model="testigo.email">
				</div>
				<div class="col-6">
					<label for="telefono">Telefono</label>
					<input type="number" class="form-control" id="telefono" v-model="testigo.telefono">
				</div>
				<div class="col-12 my-3" v-if="results">
					<button class="btn btn-primary" @click="asignPuesto" :disabled="!puestoRegistro || loader">Agregar mesas</button>
				</div>
			</div>
		</b-modal>
		<VerTestigos ref="verTestigos" @actualizado="cargarLideresPuestos" />
        <div class="col-12">
            <div class="personal-cabecera">
                <div>
                    <button type="button" class="btn btn-outline-secondary mb-2" @click="regresar"><b-icon icon="arrow-left" /> Volver</button>
                    <h3>Testigos</h3>
                </div>
                <div>
                    <button type="button" class="btn btn-success"><b-icon icon="download" /> Descargar testigos</button>
                    <button type="button" class="btn btn-primary" @click="newTestigo"><b-icon icon="plus" /> Nuevo testigo</button>
                </div>
            </div>
            <div class="personal-busqueda row">
                <div class="col-md-5">
                    <label for="buscar-puesto-testigos" class="form-label">Buscar puesto de votación</label>
                    <input id="buscar-puesto-testigos" v-model="busquedaPuesto" type="search" class="form-control" placeholder="Escribe el nombre del puesto">
                </div>
                <div class="col-md-5">
                    <label for="filtro-lider-testigos" class="form-label">Líder</label>
                    <div class="filtro-lider-controles">
                    <a-select id="filtro-lider-testigos" v-model="filtroLider" show-search allow-clear
                        :filter-option="filtrarLider" :loading="cargandoLideres || cargandoResumen" :disabled="cargandoLideres"
                        placeholder="Todos los líderes" style="width: 100%" aria-label="Filtrar puestos por líder">
                        <a-select-option v-for="lider in lideres" :key="lider.id" :value="lider.id" :title="[lider.nombres, lider.apellidos].filter(Boolean).join(' ')">
                            {{ [lider.nombres, lider.apellidos].filter(Boolean).join(' ') }}
                        </a-select-option>
                    </a-select>
                        <button type="button" class="btn btn-success" :disabled="filtroLider == null" @click="filtroLider = undefined">Limpiar líder</button>
                    </div>
                    <div v-if="errorLideres" class="text-danger" role="alert">{{ errorLideres }} <button class="btn btn-link" @click="getLideres">Reintentar</button></div>
                </div>
                <div class="col-md-2 text-md-right" role="status">{{ puestosFiltrados.length }} de {{ puestos.length }} puestos</div>
            </div>
            <div v-if="errorResumen" class="alert alert-danger" role="alert">{{ errorResumen }} <button class="btn btn-outline-danger" @click="cargarLideresPuestos">Reintentar</button></div>
            <div v-if="errorPuestos" class="alert alert-danger" role="alert">{{ errorPuestos }} <button class="btn btn-outline-danger" @click="getDivipole">Reintentar puestos</button></div>
            <div v-if="loader" class="text-center"><Loading /></div>
            <div v-else class="table-responsive">
                <table class="table">
                    <thead>
                        <tr><th scope="col">Puesto de votación</th><th scope="col">Testigos / mesas</th><th scope="col">Acciones</th></tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in puestosFiltrados" :key="[item.departamento_id, item.municipio_id, item.zona, item.puesto].join('-')">
                            <td>{{ item.nombre_puesto }}</td>
                            <td class="progreso-testigos">
                                <span v-if="cargandoResumen">Cargando…</span>
                                <span v-else-if="errorResumen">No disponible</span>
                                <template v-else>
                                    <div class="progreso-etiqueta">
                                        <span>{{ resumenTestigos[clavePuesto(item)] || 0 }} testigos / {{ item.mesas || 0 }} mesas</span>
                                        <strong>{{ progresoTestigos(item) }}%</strong>
                                    </div>
                                    <div class="progress" role="progressbar" :aria-label="'Testigos respecto a mesas en ' + item.nombre_puesto"
                                        :aria-valuenow="progresoTestigos(item)" aria-valuemin="0" aria-valuemax="100">
                                        <div class="progress-bar bg-success" :style="{ width: progresoTestigos(item) + '%' }"></div>
                                    </div>
                                </template>
                            </td>
                            <td><button type="button" class="btn btn-primary" @click="showPuesto(item.zona, item.puesto, item.nombre_puesto)">Ver testigos</button></td>
                        </tr>
                        <tr v-if="!puestosFiltrados.length"><td colspan="3" class="text-center py-4 text-muted">{{ (busquedaPuesto.trim() || filtroLider != null) ? 'No se encontraron puestos con estos filtros.' : 'No hay puestos disponibles.' }}</td></tr>
                    </tbody>
                </table>
            </div>
        </div>

	</div>	
</template>

<script>
	import axios from 'axios';
	import Loading from '../Loader/Loading.vue';
	import VerTestigos from './Testigos/VerTestigos.vue';
	import Persona from '../Persona/Persona.vue';
	import {ModelSelect} from '../../../node_modules/vue-search-select/dist/VueSearchSelect.common'
	export default {
		components:{
			Loading, ModelSelect, VerTestigos, Persona
		},
		data() {
			return {
				loader: false, errorPuestos: '',
				partidos: [],
                lideres: [], cargandoLideres: false, errorLideres: '',
				puestos: [],
                busquedaPuesto: '', filtroLider: undefined, resumenLideres: {}, resumenTestigos: {}, recargarResumen: false, cargandoResumen: false, errorResumen: '',
				results: false,
				testigo: {departamento_id: null, lidere_id: undefined}
			}
		},
        watch: {
            filtroLider() { this.cargarLideresPuestos(); }
        },
		mounted(){
			
			this.loader = true
			this.getDivipole()
			this.getPartidos()
            this.getLideres()
		},
		methods: {
            clavePuesto(puesto) {
                return [puesto.departamento_id, puesto.municipio_id, puesto.zona, puesto.puesto].map(valor => String(Number(valor))).join('-');
            },
            progresoTestigos(puesto) {
                const mesas = Number(puesto.mesas);
                if (!Number.isFinite(mesas) || mesas <= 0) return 0;
                return Math.min(100, Math.round((this.resumenTestigos[this.clavePuesto(puesto)] || 0) * 100 / mesas));
            },
            lideresDelPuesto(puesto) { return this.resumenLideres[this.clavePuesto(puesto)] || []; },
            async cargarLideresPuestos() {
                // Una petición devuelve los testigos y sus puestos, sin consultas por fila.
                if (this.cargandoResumen) { this.recargarResumen = true; return; }
                this.cargandoResumen = true;
                this.errorResumen = '';
                const liderSeleccionado = this.filtroLider;
                const config = { headers: { Authorization: `Bearer ${this.$store.state.user.token}` } };
                try {
                    const endpoint = liderSeleccionado == null ? 'api/testigos' : `api/testigos-lider/${encodeURIComponent(liderSeleccionado)}`;
                    const respuesta = await axios.get(endpoint, config);
                    if (liderSeleccionado !== this.filtroLider) return;
                    if (!Array.isArray(respuesta.data.testigos)) throw new Error('Respuesta inválida');
                    const resumen = {};
                    const cantidades = {};
                    const grupos = new Map();
                    respuesta.data.testigos.forEach(testigo => {
                        const puesto = testigo.puesto_votacion;
                        if (!Object.prototype.hasOwnProperty.call(testigo, 'puesto_votacion')) throw new Error('La API no incluye el puesto del testigo');
                        if (!puesto) return;
                        const clave = this.clavePuesto({ departamento_id: puesto.cod_dpto, municipio_id: puesto.cod_mcpio, zona: puesto.cod_zona, puesto: puesto.cod_puesto });
                        if (!grupos.has(clave)) grupos.set(clave, { testigos: new Set(), lideres: new Set() });
                        grupos.get(clave).testigos.add(String(testigo.id));
                        if (testigo.lidere_id != null) grupos.get(clave).lideres.add(String(testigo.lidere_id));
                    });
                    grupos.forEach((grupo, clave) => {
                        resumen[clave] = Array.from(grupo.lideres);
                        cantidades[clave] = grupo.testigos.size;
                    });
                    this.resumenLideres = resumen;
                    this.resumenTestigos = cantidades;
                } catch (error) {
                    if (liderSeleccionado === this.filtroLider) this.errorResumen = this.errorCarga(error, 'No se pudieron cargar los testigos por puesto.');
                } finally {
                    this.cargandoResumen = false;
                    if (this.recargarResumen) { this.recargarResumen = false; this.cargarLideresPuestos(); }
                }
            },
            errorCarga(error, mensaje) {
                if (error.response && error.response.status === 429) return 'La API alcanzó su límite de peticiones. Espera un minuto y pulsa Reintentar.';
                return mensaje;
            },
            filtrarLider(busqueda, opcion) {
                const normalizar = texto => String(texto || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                return normalizar(opcion.componentOptions.propsData.title).includes(normalizar(busqueda.trim()));
            },
            async getLideres() {
                this.cargandoLideres = true;
                this.errorLideres = '';
                try {
                    const respuesta = await axios.get('api/lideres', {
                        headers: { Authorization: `Bearer ${this.$store.state.user.token}` }
                    });
                    if (!Array.isArray(respuesta.data.lideres)) throw new Error('Respuesta de líderes inválida');
                    this.lideres = respuesta.data.lideres;
                } catch (error) {
                    this.lideres = [];
                    this.errorLideres = this.errorCarga(error, 'No se pudieron cargar los líderes.');
                } finally {
                    this.cargandoLideres = false;
                }
            },
			asignPuesto(){
                if (!this.results || !this.puestoRegistro || this.loader) return;
				this.$refs['new-testigo'].hide()
				this.$refs.verTestigos.addMesas(this.testigo)
			},
			async getDivipole(){
                this.loader = true; this.errorPuestos = '';

				const corporacion = this.$store.state.user.candidato[0].corporacione_id 
				const departamento = this.$store.state.user.candidato[0].departamento_id 
				const municipio = this.$store.state.user.candidato[0].municipio_id
				const candidato = this.$store.state.user.candidato_id
				const parametros = {
					'dpto': departamento,
					'mcpio': municipio,
					'corporacion': corporacion,
					'candidato': candidato
				}
				
				await axios.post('api/divipoles', parametros, {
					headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
				})
					.then(res => {
						// console.log(res.data.divipoles)
						if(res.data.status === 'success' && Array.isArray(res.data.divipoles)){
                            this.puestos = [];
							for (let i = 0; i < res.data.divipoles.length; i++) {
								this.puestos.push({
									departamento_id: res.data.divipoles[i].departamento_id,
									municipio_id: res.data.divipoles[i].municipio_id,
									municipio: res.data.divipoles[i].municipio,
									zona: res.data.divipoles[i].zona,
									puesto: res.data.divipoles[i].puesto,
									nombre_puesto: res.data.divipoles[i].nombre_puesto,
									mesas: res.data.divipoles[i].mesas,
									potencial: res.data.divipoles[i].num_hombres + res.data.divipoles[i].num_mujeres,
									votantes: res.data.divipoles[i].votantes
								})								
							}

						}else{
							throw new Error('Respuesta de puestos inválida')
						}
						this.loader = false;
                        this.cargarLideresPuestos();
					})
					.catch(err => {
						this.loader = false
                        this.errorPuestos = this.errorCarga(err, 'No se pudieron cargar los puestos.');
					})
			},
			getPartidos(){
				axios.get('api/partidos', {
					headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
				})
				.then(res => {
					for (let i = 0; i < res.data.partidos.length; i++) {
						this.partidos.push({
							text: res.data.partidos[i].partido,
							value: parseInt(res.data.partidos[i].codigo_partido)
						})                    
					}
				})
				.catch(err => {
					this.partidos = []
					console.log(err)
				})
			},
			newTestigo(){
				this.testigo = {departamento_id: null, lidere_id: undefined}
                this.getLideres()
				this.results = false;
				this.$refs['new-testigo'].show()
			},
			regresar(){
				this.$emit('regresar', 0)
			},
			setPersona(){
				const persona = this.getPersona

                this.$set(this.testigo, 'id', persona.cedula)
                this.$set(this.testigo, 'nom1', persona.nom1)
                this.$set(this.testigo, 'nom2', persona.nom2)
                this.$set(this.testigo, 'ape1', persona.ape1)
                this.$set(this.testigo, 'ape2', persona.ape2)
                this.$set(this.testigo, 'cedula', persona.cedula)
                this.$set(this.testigo, 'estado', persona.estado)
                this.$set(this.testigo, 'departamento_id', persona.dpto)
                this.$set(this.testigo, 'municipio_id', persona.mcpio)
                this.$set(this.testigo, 'comuna', persona.comuna)
                this.$set(this.testigo, 'zona', persona.zona)
                this.$set(this.testigo, 'puesto', persona.puesto)
                this.$set(this.testigo, 'nombre_puesto', persona.nombre_puesto)
                this.$set(this.testigo, 'mesa', persona.mesa)
                this.results = true;
            },
			showPuesto(zona, puesto, nombre_puesto){
				this.$refs.verTestigos.testigos(zona, puesto, nombre_puesto)
			}
		},
        computed:{
            puestosMunicipio() {
                const candidato = (this.$store.state.user.candidato || [])[0] || {};
                return this.puestos.filter(puesto =>
                    Number(puesto.departamento_id) === Number(candidato.departamento_id) &&
                    Number(puesto.municipio_id) === Number(candidato.municipio_id)
                );
            },
            puestoRegistro: {
                get() {
                    // setPersona actualiza estos códigos; el selector refleja el puesto encontrado.
                    const clave = this.clavePuesto(this.testigo);
                    const puesto = this.puestosMunicipio.find(item => this.clavePuesto(item) === clave);
                    return puesto ? this.clavePuesto(puesto) : undefined;
                },
                set(clave) {
                    const puesto = this.puestosMunicipio.find(item => this.clavePuesto(item) === clave);
                    if (!puesto) return;
                    if (clave !== this.clavePuesto(this.testigo)) this.$set(this.testigo, 'mesa', null);
                    ['departamento_id', 'municipio_id', 'zona', 'puesto', 'nombre_puesto'].forEach(campo => {
                        this.$set(this.testigo, campo, puesto[campo]);
                    });
                }
            },
            puestosFiltrados() {
                const normalizar = texto => String(texto || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                const busqueda = normalizar(this.busquedaPuesto.trim());
                return this.puestos.filter(puesto => normalizar(puesto.nombre_puesto).includes(busqueda) &&
                    (this.filtroLider == null || (!this.cargandoResumen && !this.errorResumen && this.lideresDelPuesto(puesto).includes(String(this.filtroLider)))));
            },
            getPersona(){                
                return this.$store.getters.getPersona
            }
        }
	}
</script>
<style scoped src="../../assets/styles/personal-admin.css"></style>
<style scoped>
.testigos-admin .progreso-testigos { min-width: 220px; }
.testigos-admin .progreso-etiqueta { display: flex; justify-content: space-between; gap: 12px; margin-bottom: 6px; font-size: 0.85rem; }
.testigos-admin .progress { height: 10px; background: #e1e8e4; border-radius: 8px; }
.testigos-admin .progress-bar { border-radius: 8px; }
.testigos-admin .table td:last-child { width: 160px; white-space: nowrap; }
.testigos-admin .table .btn { min-height: 36px; padding: 0.4rem 0.75rem; font-size: 0.875rem; }
.testigos-admin .filtro-lider-controles { display: flex; align-items: center; gap: 8px; }
.testigos-admin .filtro-lider-controles .ant-select { flex: 1; min-width: 0; }
.testigos-admin .filtro-lider-controles .btn { flex-shrink: 0; }
.testigos-admin .form-label { color: #334155; font-weight: 600; }
</style>
